import { useEffect, useState } from 'react';

import axios, { type AxiosResponse } from 'axios';

import type { IOrder } from '@admin/types/order';

import { useAxiosRequest } from './use_axios_request';

export const useAccountReturnRequest = (accountID: number | string, orderID: number | string) => {
  const [request, setRequest] = useState<Promise<AxiosResponse<IOrder>> | undefined>();

  useEffect(() => {
    setRequest(axios.get<IOrder>(`/accounts/${accountID}/returns/${orderID}.json`));
  }, [accountID, orderID]);

  return useAxiosRequest(request);
};
